import { faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import SubNavRail from '@/components/SubNavRail';
import AppContext from '@/contexts/appContext';
import { getAvailableBillingNavOptions } from '@/utils/billingNavOptions';
import resolveCurrentNavLabel from '@/utils/resolveCurrentNavLabel';

/**
 * The billing section's rail. Replaces the row of buttons the dashboard used to carry as the way
 * into remits, reports and items.
 */
const BillingSidebarNav = () => {
  const { pathname } = useLocation();
  const { permissions } = useContext(AppContext);

  const items = useMemo(() => getAvailableBillingNavOptions(permissions), [permissions]);

  const currentLabel = resolveCurrentNavLabel(items, pathname);

  const title = (
    <>
      <FontAwesomeIcon
        aria-hidden="true"
        className="h-5 w-5 shrink-0 text-green-600"
        icon={faFileInvoiceDollar}
      />
      <span className="truncate text-sm font-semibold text-gray-900">Billing</span>
    </>
  );

  return (
    <SubNavRail
      ariaLabel="Billing"
      title="Billing"
      items={items}
      currentLabel={currentLabel}
      header={<span className="flex min-w-0 items-center gap-x-2">{title}</span>}
      collapsedHeader={
        <span className="mx-auto flex items-center" title="Billing">
          <FontAwesomeIcon
            aria-hidden="true"
            className="h-5 w-5 shrink-0 text-green-600"
            icon={faFileInvoiceDollar}
          />
        </span>
      }
    />
  );
};

export default React.memo(BillingSidebarNav);
